/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '../../data/constants';

const slice = createSlice({
  name: 'studioHome',
  initialState: {
    loadingStatuses: {
      studioHomeLoadingStatus: RequestStatus.IN_PROGRESS,
      courseNotificationLoadingStatus: RequestStatus.IN_PROGRESS,
      courseLoadingStatus: RequestStatus.IN_PROGRESS,
      libraryLoadingStatus: RequestStatus.IN_PROGRESS,
    },
    savingStatuses: {
      courseCreatorSavingStatus: '',
      deleteNotificationSavingStatus: '',
    },
    studioHomeData: {},
    studioHomeCoursesRequestParams: {
      currentPage: 1,
      search: undefined,
      order: 'display_name',
      archivedOnly: undefined,
      activeOnly: undefined,
      language: undefined,
      isFiltered: false,
      cleanFilters: false,
    },
    studioHomeLibrariesRequestParams: {
      search: undefined,
      order: 'display_name',
      language: undefined,
      course: undefined,
      isFiltered: false,
      cleanFilters: false,
    },
  },
  reducers: {
    updateLoadingStatuses: (state, { payload }) => {
      state.loadingStatuses = { ...state.loadingStatuses, ...payload };
    },
    updateSavingStatuses: (state, { payload }) => {
      state.savingStatuses = { ...state.savingStatuses, ...payload };
    },
    fetchStudioHomeDataSuccess: (state, { payload }) => {
      Object.assign(state.studioHomeData, payload);
    },
    fetchCourseDataSuccess: (state, { payload }) => {
      const { courses, archivedCourses, inProcessCourseActions } = payload;
      state.studioHomeData.courses = courses;
      state.studioHomeData.archivedCourses = archivedCourses;
      state.studioHomeData.inProcessCourseActions = inProcessCourseActions;
    },
    fetchCourseDataSuccessV2: (state, { payload }) => {
      const { courses, archivedCourses = [], inProcessCourseActions } = payload.results;
      const { numPages, count } = payload;
      state.studioHomeData.courses = courses;
      state.studioHomeData.archivedCourses = archivedCourses;
      state.studioHomeData.inProcessCourseActions = inProcessCourseActions;
      state.studioHomeData.numPages = numPages;
      state.studioHomeData.coursesCount = count;
    },
    fetchLibraryDataSuccess: (state, { payload }) => {
      const { libraries } = payload;
      state.studioHomeData.libraries = libraries;
    },
    fetchLibraryDataSuccessV2: (state, { payload }) => {
      const { libraries } = payload.results;
      state.studioHomeData.libraries = libraries;
    },
    fetchLibraryFilterCoursesSuccess: (state, { payload }) => {
      state.studioHomeData.libraryFilterCourses = payload.results.courses;
    },
    fetchCourseFilterLanguagesSuccess: (state, { payload }) => {
      state.studioHomeData.courseFilterLanguages = payload.languages;
    },
    updateStudioHomeCoursesCustomParams: (state, { payload }) => {
      Object.assign(state.studioHomeCoursesRequestParams, payload);
    },
    updateStudioHomeLibrariesCustomParams: (state, { payload }) => {
      Object.assign(state.studioHomeLibrariesRequestParams, payload);
    },
  },
});

export const {
  updateSavingStatuses,
  updateLoadingStatuses,
  fetchStudioHomeDataSuccess,
  fetchCourseDataSuccess,
  fetchCourseDataSuccessV2,
  fetchLibraryDataSuccess,
  fetchLibraryDataSuccessV2,
  fetchLibraryFilterCoursesSuccess,
  fetchCourseFilterLanguagesSuccess,
  updateStudioHomeCoursesCustomParams,
  updateStudioHomeLibrariesCustomParams,
} = slice.actions;

export const {
  reducer,
} = slice;
